import { Case, Tag, User, Category } from "src/api/classes";
import store from ".";
import {
  setCases,
  setTags,
  setCategories,
  setUsers,
  loadCachedCases
} from "./cases/actions";
export let db: IDBDatabase;
export let Cases: IDBObjectStore;
const DATABASE_NAME = "Dubito";
const VERSION = 2;
const TABLE_CASES = "cases";
const TABLE_TAGS = "tags";
const TABLE_USERS = "users";
const TABLE_CATEGORIES = "categories";

type TableType = "cases" | "tags" | "users" | "categories";
export function createDatabase() {
  var request = indexedDB.open(DATABASE_NAME, VERSION);
  request.onerror = function(event) {
    alert("Why didn't you allow my web app to use IndexedDB?!");
  };
  request.onsuccess = function(event) {
    db = request.result;
    //alert("DB created");
    getCases();
    getUsers();
    getCategories();
    getTags();
    //Cases = db.createObjectStore("cases", { keyPath: "id" });
  };
  request.onupgradeneeded = function(event) {
    // Save the IDBDatabase interface
    var db = request.result;
    // Create an objectStore for this database
    Cases = db.createObjectStore(TABLE_CASES, { keyPath: "id" });
    Cases = db.createObjectStore(TABLE_USERS, { keyPath: "id" });
    Cases = db.createObjectStore(TABLE_TAGS, { keyPath: "id" });
    Cases = db.createObjectStore(TABLE_CATEGORIES, { keyPath: "id" });
  };
}
export function cleanDatabase() {
  indexedDB.deleteDatabase(DATABASE_NAME);
}
export function getCases() {
  getAll(TABLE_CASES).then(items => {
    if (items.length === 0) {
      store.dispatch(loadCachedCases(undefined));
      return;
    }
    if (items && items.length > 0) {
      items = items
        .filter(i => i.folder !== "deleted")
        .sort((a, b) => b.id - a.id);
    }
    store.dispatch(loadCachedCases(items));
  });
}
export function getTags() {
  getAll(TABLE_TAGS).then(items => {
    if (items.length === 0) {
      return;
    }
    store.dispatch(setTags(items));
  });
}
export function getCategories() {
  getAll(TABLE_CATEGORIES).then(items => {
    if (items.length === 0) {
      return;
    }
    store.dispatch(setCategories(items));
  });
}
export function getUsers() {
  getAll(TABLE_USERS).then(items => {
    if (items.length === 0) {
      return;
    }
    store.dispatch(setUsers(items));
  });
}
export function getAll(table: TableType): Promise<any> {
  return new Promise((resolve, reject) => {
    const tr = db.transaction(table, "readonly");
    const req = tr.objectStore(table).openCursor();
    const items = [];
    req.onsuccess = function(event) {
      const cursor = req.result;
      if (cursor) {
        items.push(cursor.value);
        cursor.continue();
      } else {
        resolve(items);
      }
    };
  });
}
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
export function saveAll(table: TableType, items: any[]): Promise<any> {
  return new Promise(async (resolve, reject) => {
    while (!db) {
      // wait for db
      console.log("wait for db");
      await sleep(100);
    }
    const tr = db.transaction(table, "readwrite");
    items.forEach(c => {
      tr.objectStore(table).put(c);
    });
  });
}
export function updateCases(table: TableType, items: any[]): Promise<any> {
  return new Promise(async (resolve, reject) => {
    while (!db) {
      // wait for db
      console.log("wait for db");
      await sleep(100);
    }
    const tr = db.transaction(table, "readwrite");
    items.forEach(c => {
      tr.objectStore(table).put(c);
    });
  });
}
export function updateCase(_case: Case): Promise<any> {
  return new Promise(async (resolve, reject) => {
    while (!db) {
      // wait for db
      console.log("wait for db");
      await sleep(100);
    }
    const tr = db.transaction(TABLE_CASES, "readwrite");
    tr.objectStore(TABLE_CASES).put(_case);
  });
}
export async function saveCases(items: Case[]) {
  saveAll(TABLE_CASES, items);
}
export async function saveTags(items: Tag[]) {
  saveAll(TABLE_TAGS, items);
}
export async function saveUsers(items: User[]) {
  saveAll(TABLE_USERS, items);
}
export async function saveCategories(items: Category[]) {
  saveAll(TABLE_CATEGORIES, items);
}



// WEBPACK FOOTER //
// ./src/store/db.ts